import * as React from 'react';

import type { MessengerAttachment } from 'types';

type Props = {
  data: Array<MessengerAttachment>
};

const DocumentsPanel = ({
  data
}: Props) => (
  <section className="documents-panel">
    <ul className="documents-panel__documents">
      {
        data.map(item => (
          <li
            key={item.key}
            className="documents-panel__documents-item"
          >
            <a
              href={item.url}
              title={item.name}
              rel="noopener noreferrer"
              target="_blank"
            >
              <span>{item.name}</span>
            </a>
          </li>
        ))
      }
    </ul>
  </section>
);

export default DocumentsPanel;
